export const SessionStorageKeys = {
  Visited: 'visited',
}; 